import { MutableRefObject, useCallback } from 'react'

export const useScrollTo = (ref: MutableRefObject<HTMLDivElement | null>, offset = 80) => useCallback(() => {
  if (ref.current) {
    const { top: elementYPosition } = ref.current.getBoundingClientRect()
    const { scrollTop } = document.documentElement
    const target = elementYPosition + scrollTop - offset

    window.scrollTo({
      behavior: 'smooth',
      top: target,
    })
  }
}, [ref, offset])
